import { h } from "preact";
import omit from "lodash/omit";

import SegmentedControlItem from "./SegmentedControlItem.jsx";

export default function SegmentedControl({ items }) {
  return (
    <div class="segmented-control__wrapper">
      <div class="segmented-control" role="menu">
        {items.map((item, i) => (
          <SegmentedControlItem {...omit(item, ["text"])}>
            {item.text}
          </SegmentedControlItem>
        ))}
      </div>
    </div>
  );
}
